import { render, staticRenderFns } from "./ConsultationDetail.vue?vue&type=template&id=2cf2030d&scoped=true"
import script from "./ConsultationDetail.vue?vue&type=script&lang=js"
export * from "./ConsultationDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsultationDetail.vue?vue&type=style&index=0&id=2cf2030d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2030d",
  null
  
)

export default component.exports